import { SweetAlertService } from 'app/main/services/sweet-alert/sweet-alert.service';
import { PermissionService } from './../../../../services/permissions/permission.service';
import { Role } from './../../../../models/roles/role';
import { RoleService } from 'app/main/services/roles/role.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { fuseAnimations } from '../../../../../core/animations';
import { MatPaginator, MatSort, MatSelectionList, MatDialogConfig, MatDialog } from '@angular/material';
import { Permission } from 'app/main/models/permissions/permission';
import { FuseAddRoleComponent } from 'app/main/content/pages/security/roles-and-permissions/components/add-role/add-role.component';
import { TranslateService } from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TranslationService } from 'app/main/services/translation/translation.service';

@Component({
    selector: 'fuse-security-roles-and-permissions',
    templateUrl: './roles-and-permissions.component.html',
    styleUrls: ['./roles-and-permissions.component.scss'],
    animations: fuseAnimations
})
export class FuseRolesAndPermissionsComponent implements OnInit {

    @BlockUI('tracker') blockUI: NgBlockUI;

    confirmDialogRef: any;
    roles: Role[];
    permissions: Permission[];

    constructor(
        private roleService: RoleService,
        private permissionService: PermissionService,
        public dialog: MatDialog,
        private sweetAlertService: SweetAlertService,
        private translateService: TranslateService,
        private translationService: TranslationService
    ) {
        this.roles = [];
    }

    ngOnInit() {        
        this.getAllRoles();
        this.getAllPermissions();
    }

    getAllRoles() {
        this.roleService.getAll().subscribe(response => {
            console.log('FuseRolesAndPermissionsComponent > getAllRoles > this.roleService.getAll() > response', response);
            this.roles = response;
            for (const role of this.roles) {
                role.Permissions = [];
                role.IsAllPermissionsChecked = false;
            }
        }, error => {
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            })
        });
    }

    getAllPermissions() {
        this.permissionService.getAll().subscribe(response => {
            console.log('FuseRolesAndPermissionsComponent > getAllPermissions > this.roleService.getAll() > response', response);
            if (response.ResultCode == 1) {
                this.permissions = response.Result;                
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            }
        }, error => {
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            })
        });
    }

    checkToggle(role: Role) {
        // console.log('FuseRolesAndPermissionsComponent > checkToggle > role', role);
        role.IsAllPermissionsChecked = !role.IsAllPermissionsChecked;
        for (const permission of role.Permissions) {
            if (permission.Name != 'PAGES_HOME') {
                permission.IsGranted = role.IsAllPermissionsChecked;
            }
        }
    }

    checkIfIsAllPermissionsChecked(role: Role, permission?: Permission) {
        if (!!permission) {
            let permission2 = role.Permissions.find(p => p.Id == permission.Id);
            permission2.IsGranted = !permission2.IsGranted;
        }
        // console.log('FuseRolesAndPermissionsComponent > checkIfIsAllPermissionsChecked > role', role);
        let isAllPermissionsChecked = true;
        for (const permission of role.Permissions) {
            if (!permission.IsGranted) {
                isAllPermissionsChecked = false;
                break;
            }
        }
        role.IsAllPermissionsChecked = isAllPermissionsChecked;
    }

    getPermissionsByApplicationRoleId(applicationRoleId: string) {
        let role = this.roles.find(ar => ar.Id == applicationRoleId);
        if (role.Permissions.length > 0) {
            return;
        }
        this.permissionService.getByApplicationRoleId(applicationRoleId).subscribe(response => {
            if (response.ResultCode == 1) {
                role.Permissions = response.Result;
                this.checkIfIsAllPermissionsChecked(role);
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            }
        }, error => {
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            })
        });
    }

    openAddRoleDialog() {
        let newApplicationRole = new Role();
        newApplicationRole.Id = '';
        newApplicationRole.Name = '';
        newApplicationRole.Description = '';
        newApplicationRole.Permissions = this.permissions;
        newApplicationRole.IsAllPermissionsChecked = false;

        const config: MatDialogConfig = {
            // height: '75%',
            width: '60%',
            height: '95%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                role: JSON.parse(JSON.stringify(newApplicationRole))
            }
        };

        this.confirmDialogRef = this.dialog.open(FuseAddRoleComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseRolesAndPermissionsComponent > openAddRoleDialog > result', result);
            console.log('FuseRolesAndPermissionsComponent > openAddRoleDialog > newApplicationRole', newApplicationRole);
            if (result != true) {
                this.roles.push(result);
            }
        });
    }

    saveChanges(role: Role) {
        console.log('FuseRolesAndPermissionsComponent > saveChanges > role', role);
        this.blockUI.start(this.translationService.savingChanges);
        let permissionIds = [];
        for (const permission of role.Permissions) {
            if (permission.IsGranted) {
                permissionIds.push(permission.Id);
            }
        }
        this.roleService.edit(role.Id, role.Name, role.Description, permissionIds).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode == 1) {
                this.sweetAlertService.success(this.translationService.success, this.translationService.changesSavedCorrectly, null);
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            })
        });
    }

    removeRole(role: Role, $event: any) {
        $event.preventDefault();
        $event.stopPropagation();
        this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', role.Name, (res) => {
            this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
                this.roleService.delete(role.Id).subscribe(response => {
                    if (response.ResultCode == 1) {
                        let index = this.roles.findIndex(ar => ar.Id == role.Id)
                        this.roles.splice(index, 1);
                        this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                    } else {
                        this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                            this.sweetAlertService.error('Error', res, null);
                        })
                    }
                }, error => {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    })
                });
            }, () => {
                console.log('FuseRolesAndPermissionsComponent > removeRole > canceled');
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/security/roles-and-permissions/roles-and-permissions.component.ts